export default {
  settings: {
    mimeType: 'application/ld+json',
    corsEnabled: true
  },
  environments: {
    staging: 'https://reactions.staging-api.immediate.co.uk',
    preproduction: 'https://reactions.preproduction-api.immediate.co.uk',
    production: 'https://reactions.api.immediate.co.uk'
  },
  endpoints: {
    reactions: {
      endpoint: '/api/reactions'
    },
    aggregateRatings: {
      endpoint: '/api/aggregate_ratings'
    },
    likes: {
      endpoint: '/api/likes'
    },
    ratings: {
      endpoint: '/api/ratings'
    },
    replies: {
      endpoint: '/api/replies'
    },
    comments: {
      endpoint: '/api/comments'
    },
    questions: {
      endpoint: '/api/questions'
    },
    tips: {
      endpoint: '/api/tips'
    }
  }
};